import React from 'react';
import axios from 'axios';
import { Form, Switch, Row, Col, Card, message } from 'antd';
import Contract from 'components/Contract';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import AgeAgreementWarning from 'components/AgeAgreementWarning';
import apiPath from 'apiPath';

class SignatoryStatement extends React.Component {

    state = {
        SRI_SIGN_ALCOHOL: null,
        SRI_SIGN_DRUG: null,
        SRI_SIGN_FIRE: null,
        SRI_SIGN_PGRAD: null,
        alcoholChecked: null,
        drugChecked: null,
        fireChekced: null,
        gradChecked: null
    }

    //Getting signatory status from props and then setting them into state
    getStatusesFromProps = (props) => {
        const statuses = props.statuses || {};
        this.setState({
            SRI_SIGN_ALCOHOL: statuses.SRI_SIGN_ALCOHOL,
            SRI_SIGN_DRUG: statuses.SRI_SIGN_DRUG,
            SRI_SIGN_FIRE: statuses.SRI_SIGN_FIRE,
            SRI_SIGN_PGRAD: statuses.SRI_SIGN_PGRAD,
            alcoholChecked: statuses.SRI_SIGN_ALCOHOL === 'R' || statuses.SRI_SIGN_ALCOHOL === 'E' ? true : false,
            drugChecked: statuses.SRI_SIGN_DRUG === 'R' || statuses.SRI_SIGN_DRUG === 'E' ? true : false,
            fireChekced: statuses.SRI_SIGN_FIRE === 'R' || statuses.SRI_SIGN_FIRE === 'E' ? true : false,
            gradChecked: statuses.SRI_SIGN_PGRAD === 'R' || statuses.SRI_SIGN_PGRAD === 'E' ? true : false
        });
    }

    //Updating signatory status to "R" if a user has checked.  If admin first checks in basic info, it sets status to "E"
    handleSubmit = (event) => {
        event.preventDefault();
        this.props.isSubmitting();
        this.props.updateStatuses(this.props.form, 'R')
            .catch(console.error)
            .then(() => { this.props.isSubmitted(); });
    }

    //Update signatory status to "E" for admin users. Update to "D" for delete if status is already set This will make the checkboxes appear for students
    handleAdminSubmitAlcohol = () => {
        this.setState({ alcoholChecked: !this.state.alcoholChecked })
        if (this.state.SRI_SIGN_ALCOHOL === 'E' || this.state.SRI_SIGN_ALCOHOL === 'R') {
            axios.put(apiPath + '/statuses', { SRI_SIGN_ALCOHOL: 'D' }, { withCredentials: true }).then(response => {
                message.success('Saved!');
                this.props.refreshStatuses();
            })
        } else {
            axios.put(apiPath + '/statuses', { SRI_SIGN_ALCOHOL: 'E' }, { withCredentials: true }).then(response => {
                message.success('Saved!');
                this.props.refreshStatuses();
            })
        }
    }

    handleAdminSubmitDrug = () => {
        this.setState({ drugChecked: !this.state.drugChecked })
        if (this.state.SRI_SIGN_DRUG === 'E' || this.state.SRI_SIGN_DRUG === 'R') {
            axios.put(apiPath + '/statuses', { SRI_SIGN_DRUG: 'D' }, { withCredentials: true }).then(response => {
                message.success('Saved!')
                this.props.refreshStatuses();
            })
        } else {
            this.props.form.validateFields((errors, values) => {
                axios.put(apiPath + '/statuses', { SRI_SIGN_DRUG: 'E' }, { withCredentials: true }).then(response => {
                    message.success('Saved!')
                    this.props.refreshStatuses();
                })
            })
        }
    }

    handleAdminSubmitFire = () => {
        this.setState({ fireChecked: !this.state.fireChecked })
        if (this.state.SRI_SIGN_FIRE === 'E' || this.state.SRI_SIGN_FIRE === 'R') {
            axios.put(apiPath + '/statuses', { SRI_SIGN_FIRE: 'D' }, { withCredentials: true }).then(response => {
                message.success('Saved!')
                this.props.refreshStatuses();
            })
        } else {
            axios.put(apiPath + '/statuses', { SRI_SIGN_FIRE: 'E' }, { withCredentials: true }).then(response => {
                message.success('Saved!')
                this.props.refreshStatuses();
            })
        }
    }

    handleAdminSubmitPgrad = () => {
        this.setState({ gradChecked: !this.state.gradChecked })
        if (this.state.SRI_SIGN_PGRAD === 'E' || this.state.SRI_SIGN_PGRAD === 'R') {
            axios.put(apiPath + '/statuses', { SRI_SIGN_PGRAD: 'D' }, { withCredentials: true }).then(response => {
                message.success('Saved!')
                this.props.refreshStatuses();
            })
        } else {
            axios.put(apiPath + '/statuses', { SRI_SIGN_PGRAD: 'E' }, { withCredentials: true }).then(response => {
                message.success('Saved!')
                this.props.refreshStatuses();
            })
        }
    }

    componentDidMount() { this.getStatusesFromProps(this.props); }
    componentWillReceiveProps(nextProps) { this.getStatusesFromProps(nextProps); }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                {this.props.variant === 'admin' &&
                    <Card title="Staff can use these toggle switch to turn off and on which section their student needs to check">
                        <Row gutter={16}>
                            <Col span={6}>
                                <p>Signatory Alcohol</p>
                                <Switch
                                    checked={this.state.alcoholChecked}
                                    onChange={this.handleAdminSubmitAlcohol} />
                            </Col>
                            <Col span={6}>
                                <p>Signatory Drug</p>
                                <Switch checked={this.state.drugChecked}
                                    onChange={this.handleAdminSubmitDrug} />
                            </Col>
                            <Col span={6}>
                                <p>Signatory Fire</p>
                                <Switch checked={this.state.fireChekced}
                                    onChange={this.handleAdminSubmitFire} />
                            </Col>
                            <Col span={6}>
                                <p>Signatory Post Grad</p>
                                <Switch checked={this.state.gradChecked}
                                    onChange={this.handleAdminSubmitPgrad} />
                            </Col>
                        </Row>
                    </Card>
                }

                <br />
                <Form className="withSpacing" onSubmit={this.handleSubmit}>
                    {this.props.isStudent &&
                        <div>
                            <p>
                                Prior to the start of your voyage it is necessary to acknowledge that you have read and agree to the terms of the below documents.
                                Please click on each document and read the contents carefully.
                                It is recommended that you print all documents for your records.
                                After you have read all documents you must select each box to acknowledge that you have read and agree to the terms.
                                Once all boxes are checked you may click the Save button.
                    </p>
                            <br />
                            <AgeAgreementWarning />
                            <br />
                            {(this.state.SRI_SIGN_FIRE !== null) && (this.state.SRI_SIGN_FIRE !== 'U') && (this.state.SRI_SIGN_FIRE !== 'D') &&
                                <Contract
                                    getFieldDecorator={getFieldDecorator}
                                    field="SRI_SIGN_FIRE"
                                    initialValue={this.state.SRI_SIGN_FIRE}
                                    title="Fire"
                                    link="http://www.semesteratsea.org/wp-content/uploads/2016/07/Fire-Safety-and-Smoking-Signatory-Statement.pdf"
                                    agreeText="I understand that when I applied for admission to Semester at Sea, I agreed to be bound by the policies set forth in the Voyager’s Handbook. I agree to adhere to the fire safety regulations outlined in the above hyper-linked statement." />
                            }
                            <br />

                            {(this.state.SRI_SIGN_ALCOHOL !== null) && (this.state.SRI_SIGN_ALCOHOL !== 'U') && (this.state.SRI_SIGN_ALCOHOL !== 'D') &&
                                <Contract
                                    getFieldDecorator={getFieldDecorator}
                                    field="SRI_SIGN_ALCOHOL"
                                    initialValue={this.state.SRI_SIGN_ALCOHOL}
                                    title="Alcohol"
                                    link="http://www.semesteratsea.org/wp-content/uploads/2016/07/Alcohol-Signatory-Statement.pdf"
                                    agreeText="I understand that when I applied for admission to Semester at Sea, I agreed to be bound by the policies set forth in the Voyager’s Handbook. I agree to adhere to the alcohol regulations outlined in the above hyper-linked statement." />
                            }
                            <br />
                            {(this.state.SRI_SIGN_DRUG !== null) && (this.state.SRI_SIGN_DRUG !== 'U') && (this.state.SRI_SIGN_DRUG !== 'D') &&
                                <Contract
                                    getFieldDecorator={getFieldDecorator}
                                    field="SRI_SIGN_DRUG"
                                    initialValue={this.state.SRI_SIGN_DRUG}
                                    title="Drug"
                                    link="http://www.semesteratsea.org/wp-content/uploads/2016/07/Drugs-Signatory-Statement.pdf"
                                    agreeText="I understand that when I applied for admission to Semester at Sea, I agreed to be bound by the policies set forth in the Voyager’s Handbook. I agree to adhere to the drug regulations outlined in the above hyper-linked statement." />
                            }
                            <br />
                            {(this.state.SRI_SIGN_PGRAD !== null) && (this.state.SRI_SIGN_PGRAD !== 'U') && (this.state.SRI_SIGN_PGRAD !== 'D') &&
                                <Contract
                                    getFieldDecorator={getFieldDecorator}
                                    field="SRI_SIGN_PGRAD"
                                    initialValue={this.state.SRI_SIGN_PGRAD}
                                    title="Post Grad"
                                    link="http://www.semesteratsea.org/wp-content/uploads/2016/07/Academic-Participation-Signatory-Statement.pdf"
                                    agreeText="I understand that when I applied for admission to Semester at Sea, I agreed to be bound by the policies set forth in the Voyager’s Handbook. I agree to participate fully in the academic program during my voyage on Semester at Sea as outlined in the above hyper-linked statement." />
                            }
                        </div>
                    }
                    {this.props.variant !== 'admin' &&
                        <SaveButton
                            disabled={!this.props.form.isFieldsTouched()}
                            loading={this.props.getStatus().submitting} />
                    }

                </Form>
            </div>
        );
    }
}

export default withSpin(Form.create()(SignatoryStatement));


// WEBPACK FOOTER //
// ./portal-components/Portal/Admissions/SignatoryStatement.jsx